module.exports = __webpack_public_path__ + "static/img/asfasfafasfsafsaf.94466cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/asfasfafasfsafsaf.png
// module id = FtXC
// module chunks = 2